import React from "react";

function WhatWeDo() {
  return (
    <div>
      {/* <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">What we do</h4>
                <h2 className="title split-text-right split-text-in-right">
                  AI-optimized design for innovative solutions
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-5">
              <div
                className="services-style-two-colum-large text-light fade-up-anim"
                style={{
                  backgroundImage:
                    "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-8.jpg)",
                }}
              >
                <h3 className="text-end">
                  <a>
                    Developing machine <br /> learning models
                  </a>
                </h3>
                <ul className="service-list mt-70 mt-xs-30">
                  <li>
                    <div className="icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/icon/1.png"
                        alt="Image Not Found"
                      />
                    </div>
                    <div className="info">
                      <h4>
                        <a>Language Translation</a>
                      </h4>
                      <p>
                        The process of converting text or total speech from one
                        language.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/icon/2.png"
                        alt="Image Not Found"
                      />
                    </div>
                    <div className="info">
                      <h4>
                        <a>Content Writting</a>
                      </h4>
                      <p>
                        The process of creating and publishing written
                        professional content.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-7">
              <div className="services-style-two-items fade-up-anim">
                <div className="services-style-two-item">
                  <div className="top-info">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/7.png"
                      alt="Image Not Found"
                    />
                    <h4>
                      <a>
                        Next-gen computer <br /> vision solutions
                      </a>
                    </h4>
                    <ul className="list-style-one">
                      <li>Real-time object detection </li>
                      <li>AR-powered assistance</li>
                      <li>Markerless AR tracking</li>
                    </ul>
                  </div>
                  <a href="#" className="btn-simple">
                    Explore More
                  </a>
                </div>

                <div className="services-style-two-item fade-up-anim">
                  <div className="top-info">
                    <img
                      src="https://validthemes.net/site-template/robok/assets/img/icon/6.png"
                      alt="Image Not Found"
                    />
                    <h4>
                      <a>
                        Data-driven and <br /> predictions solution
                      </a>
                    </h4>
                    <ul className="list-style-one">
                      <li>Business Intelligence</li>
                      <li>Real-time Data Monitoring</li>
                      <li>Demand Forecasting</li>
                    </ul>
                  </div>
                  <div className="bottom">
                    <div className="fun-fact">
                      <div className="js-counter">218K</div>
                      <h5>Worldwide Users</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a Security Token Exchange ?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A security token exchange is a digital platform that
                  facilitates the buying, selling, and trading of security
                  tokens, which represent ownership in real-world assets like
                  stocks, bonds, real estate, or other financial instruments.
                  Unlike cryptocurrencies, security tokens are subject to
                  regulatory oversight because they represent regulated
                  financial securities. These tokens offer investors legal
                  rights, such as equity ownership, dividends, or revenue
                  sharing, depending on the asset they are tied to.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </div>
  );
}

export default WhatWeDo;
